import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const FilterPanel = ({ filters, onFilterChange, onReset, onSavePreset, onApply }) => {
  const sectorOptions = [
    { value: 'all', label: 'All Sectors' },
    { value: 'government', label: 'Government' },
    { value: 'healthcare', label: 'Healthcare' },
    { value: 'education', label: 'Education' },
    { value: 'finance', label: 'Finance' },
    { value: 'telecom', label: 'Telecom' },
    { value: 'energy', label: 'Energy' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Statuses' },
    { value: 'qualified', label: 'Qualified' },
    { value: 'proposal', label: 'Proposal' },
    { value: 'negotiation', label: 'Negotiation' },
    { value: 'won', label: 'Won' },
    { value: 'lost', label: 'Lost' }
  ];

  const roleOptions = [
    { value: 'all', label: 'All Roles' },
    { value: 'lead', label: 'Lead' },
    { value: 'support', label: 'Support' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-16 md:p-20 lg:p-24 shadow-elevation-sm">
      <div className="flex items-center justify-between mb-16">
        <div className="flex items-center gap-8">
          <Icon name="Filter" size={20} className="text-primary" />
          <h3 className="text-base md:text-lg font-semibold text-foreground">Filters</h3>
        </div>
        <Button
          variant="ghost"
          size="sm"
          iconName="RotateCcw"
          iconPosition="left"
          iconSize={16}
          onClick={onReset}
        >
          Reset
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-16 mb-16">
        <Select
          label="Sector"
          options={sectorOptions}
          value={filters?.sector}
          onChange={(value) => onFilterChange('sector', value)}
        />

        <Select
          label="Status"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
        />

        <Select
          label="Engagement Role"
          options={roleOptions}
          value={filters?.role}
          onChange={(value) => onFilterChange('role', value)}
        />

        <Input
          label="Search"
          type="search"
          placeholder="Search opportunities..."
          value={filters?.search}
          onChange={(e) => onFilterChange('search', e?.target?.value)}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 mb-16">
        <Input
          label="Min Value (OMR)"
          type="number"
          placeholder="0"
          value={filters?.minValue}
          onChange={(e) => onFilterChange('minValue', e?.target?.value)}
        />

        <Input
          label="Max Value (OMR)"
          type="number"
          placeholder="1000000"
          value={filters?.maxValue}
          onChange={(e) => onFilterChange('maxValue', e?.target?.value)}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 mb-16">
        <Input
          label="From Date"
          type="date"
          value={filters?.fromDate}
          onChange={(e) => onFilterChange('fromDate', e?.target?.value)}
        />

        <Input
          label="To Date"
          type="date"
          value={filters?.toDate}
          onChange={(e) => onFilterChange('toDate', e?.target?.value)}
        />
      </div>
      <div className="flex items-center gap-12 pt-16 border-t border-border">
        <Button
          variant="outline"
          size="sm"
          iconName="Save"
          iconPosition="left"
          iconSize={16}
          onClick={onSavePreset}
        >
          Save as Preset
        </Button>
        <Button
          variant="default"
          size="sm"
          iconName="Check"
          iconPosition="left"
          iconSize={16}
          onClick={onApply}
          className="ml-auto"
        >
          Apply Filters
        </Button>
      </div>
    </div>
  );
};

export default FilterPanel;